import ReactFlagsSelect from "react-flags-select";

const COUNTRIES = [
  { iso2: "DZ", name: "Algeria" },
  { iso2: "AO", name: "Angola" },
  { iso2: "BJ", name: "Benin" },
  { iso2: "BW", name: "Botswana" },
  { iso2: "BF", name: "Burkina Faso" },
  { iso2: "BI", name: "Burundi" },
  { iso2: "CV", name: "Cabo Verde" },
  { iso2: "CM", name: "Cameroon" },
  { iso2: "CF", name: "Central African Republic" },
  { iso2: "TD", name: "Chad" },
  { iso2: "KM", name: "Comoros" },
  { iso2: "CD", name: "Congo (DRC)" },
  { iso2: "CG", name: "Congo (Republic)" },
  { iso2: "CI", name: "Côte d'Ivoire" },
  { iso2: "DJ", name: "Djibouti" },
  { iso2: "EG", name: "Egypt" },
  { iso2: "GQ", name: "Equatorial Guinea" },
  { iso2: "ER", name: "Eritrea" },
  { iso2: "SZ", name: "Eswatini" },
  { iso2: "ET", name: "Ethiopia" },
  { iso2: "GA", name: "Gabon" },
  { iso2: "GM", name: "Gambia" },
  { iso2: "GH", name: "Ghana" },
  { iso2: "GN", name: "Guinea" },
  { iso2: "GW", name: "Guinea-Bissau" },
  { iso2: "KE", name: "Kenya" },
  { iso2: "LS", name: "Lesotho" },
  { iso2: "LR", name: "Liberia" },
  { iso2: "LY", name: "Libya" },
  { iso2: "MG", name: "Madagascar" },
  { iso2: "MW", name: "Malawi" },
  { iso2: "ML", name: "Mali" },
  { iso2: "MR", name: "Mauritania" },
  { iso2: "MU", name: "Mauritius" },
  { iso2: "MA", name: "Morocco" },
  { iso2: "MZ", name: "Mozambique" },
  { iso2: "NA", name: "Namibia" },
  { iso2: "NE", name: "Niger" },
  { iso2: "NG", name: "Nigeria" },
  { iso2: "RW", name: "Rwanda" },
  { iso2: "ST", name: "São Tomé & Príncipe" },
  { iso2: "SN", name: "Senegal" },
  { iso2: "SC", name: "Seychelles" },
  { iso2: "SL", name: "Sierra Leone" },
  { iso2: "SO", name: "Somalia" },
  { iso2: "ZA", name: "South Africa" },
  { iso2: "SS", name: "South Sudan" },
  { iso2: "SD", name: "Sudan" },
  { iso2: "TZ", name: "Tanzania" },
  { iso2: "TG", name: "Togo" },
  { iso2: "TN", name: "Tunisia" },
  { iso2: "UG", name: "Uganda" },
  { iso2: "ZM", name: "Zambia" },
  { iso2: "ZW", name: "Zimbabwe" },
];

export const CountrySelect = ({ value, onChange, className = "form-control", disabled = false }) => {
  const allowedCodes = COUNTRIES.map((c) => c.iso2);
  const customLabels = COUNTRIES.reduce((acc, curr) => {
    acc[curr.iso2] = curr.name;
    return acc;
  }, {});

  return (
    <ReactFlagsSelect
      selected={value}
      onSelect={(code) => onChange(code)}
      countries={allowedCodes}
      customLabels={customLabels}
      disabled={disabled}
      placeholder="Select country"
      searchable={true}
      className="my-flags-select"
    />
  );
};